import { ProviderService } from '../domain/entities/ProviderService'
import { IProviderServiceRepository } from '../domain/repositories/IProviderServiceRepository'

export class GetProviderServicesUseCase {
  constructor(private readonly repository: IProviderServiceRepository) {}

  execute(providerId: number): Promise<ProviderService[]> {
    return this.repository.getProviderServices(providerId)
  }
}
